import * as Constants from './lib/Constants';

export default function index(themeCss, customCss, themeName) {
  if (themeCss) {
    themeCss = decodeURIComponent(themeCss);
  } else {
    themeCss = `${Constants.THEME_BASE_URL}/${
      themeName || Constants.THEME_DEFAULT
    }.css`;
  }
  if (customCss) {
    customCss = decodeURIComponent(customCss);
  }

  const themeCssLink = `
  <link
  rel="stylesheet"
  href="${themeCss}"/>`;

  let customCssLink = '';
  if (customCss) {
    customCssLink = `
   <link 
   rel="stylesheet"
   href="${customCss}"/>`;
  }

  return `
  <!DOCTYPE html>
  <html lang="en">
    <head>
      <meta charset="UTF-8" />
      <meta
        name="viewport"
        content="initial-scale=1.0, user-scalable=no, maximum-scale=1.0, width=device-width"
      />
      <meta http-equiv="X-UA-Compatible" content="ie=edge" />
      <title>Flow XO Web Messenger</title>
      ${themeCssLink}
      ${customCssLink}
    </head>
    <body>
      <div id="app" class="web-messenger">
        <div class="web-messenger-header">
          <div class="web-messenger-title">
            <div class="web-messenger-title-skeleton"></div>
          </div>
        </div>
        <div class="web-messenger-messages">
          <div class="web-messenger-message">
            <div class="web-messenger-message-icon-placeholder"></div>
            <div class="web-messenger-message-bubble">
              <div class="web-messenger-typing">
                <div class="bounce1"></div>
                <div class="bounce2"></div>
                <div class="bounce3"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <script src="${process.env.MESSENGER_URL}/messenger.dll.js"></script>
      <script src="${process.env.MESSENGER_URL}/messenger.js"></script>
    </body>
  </html>
  `;
}



// WEBPACK FOOTER //
// ./src/messenger/index.js